export const columns = [
  { key: "count", header: "S.", isSortable: false, className: "count" },
  { key: "zip", header: "Zipcode", isSortable: true, className: "dark" },
  { key: "city", header: "City", isSortable: true, className: "dark" },
  { key: "state", header: "State", isSortable: true, className: "dark" },
  { key: "country", header: "Country", isSortable: true, className: "dark" },
  { key: "latitude", header: "Latitude", isSortable: true, className: "dark" },
  { key: "longitude", header: "Longitude", isSortable: true, className: "dark" },
  { key: "active", header: "Active", isSortable: false, isActive: true, handleActive: true, className: "dark" },
];

export type ZipCodeData = {
  id?: string;
  zip: string;
  city: string;
  state: string;
  stateCode: string;
  country: string;
  countryCode: string;
  latitude: string;
  longitude: string;
  active?: boolean;
};

export type AddEditZipCodeModalProps = {
  isEdit: boolean;
  isOpen: boolean;
  onClose: () => void;
  initialData?: ZipCodeData | null;
  onSuccess?: () => void;
};
